export default "<iframe #demoIframe class=\"lsg-demo-iframe\" [src]='demoUrl | safe'></iframe>\n";